/**
 * Whether `url` is an absolute HTTP(S) URL, i.e. one that leaves the app.
 *
 * Everything else — in-app paths and other schemes alike (`ssh://`, `git@…`) —
 * is resolved relative to the current route by react-router, so links and
 * endpoints have to tell the two apart before handing a value to the router.
 */
export function isHttpUrl(url: string): boolean {
  return url.startsWith("http://") || url.startsWith("https://");
}
